module.exports = __webpack_public_path__ + "img/weiboActive.763f5269.svg";